import { EntityApi } from "../../services/ApiPlatform";
import { FinalResponse } from "../../services/ApiPlatform/models";

export abstract class MessageApi extends EntityApi {
    protected static GET_COLLECTION = "/api/messages";

    protected static POST_COLLECTION = "/api/messages";

    protected static GET_ITEM = "/api/messages/{id}";

    protected static PUT_ITEM = "/api/messages/{id}";

    protected static PATCH_ITEM = "/api/messages/{id}";

    protected static DELETE_ITEM = "/api/messages/{id}";

    protected static POST_COLLECTION_MARK_READ = "/api/messages/mark-read";

    public static async postMarkRead<R, P>(
        entity: P,
        extraParams = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.POST_COLLECTION_MARK_READ,
        };
        return this.postCollection(entity, extraParams);
    }
}
